export { default as ProjectSightModalWrapper } from '@/app/core/components/ProjectSight/ProjectSightModalWrapper'
